export default "__VITE_ASSET__D3YzIGS9__"